// @flow

import * as React from 'react';
import { Link } from '@ta/common.routing';
import { type LogInteraction, InteractionLogger } from '@ta/tracking.interactions';
import { ResponsiveImage } from '@ta/media.image';
import { globalize, localize } from '@ta/common.i18n';
import type { LocationInformation } from '@ta/common.webview';
import type { Route } from './types';
import styles from './ShelfRentalCarsSection.less';

type RentalCarsLeadOffer = {|
  location: LocationInformation,
  rentalCarsShelfPrice: number,
  rentalCarType?: string,
  route?: Route,
  carImage: string,
  seats?: number,
  bags?: number,
  scoped?: boolean,
|};

const getPhoto = (sources: any) => (
  <div className={styles.photoWrap}>
    <div className={styles.shelfForPhoto}>
      <ResponsiveImage sources={sources} width="100%" height="100%" borderRadius="2px" />
    </div>
  </div>
);

const getPhotoContainer = (url: ?string, sources: any, logInteraction: LogInteraction) => {
  if (url) {
    return (
      <Link href={url} className="ui_poi_thumbnail" onClick={e => logInteraction(e, 'feedClick')}>
        {getPhoto(sources)}
      </Link>
    );
  }
  return <div className="ui_poi_thumbnail">{getPhoto(sources)}</div>;
};

const getOffer = (currencyFare: string, rentalCarsLeadOffer: RentalCarsLeadOffer) => (
  <React.Fragment>
    {!rentalCarsLeadOffer.scoped && (
      <span className={`${styles.name}`}>{rentalCarsLeadOffer.location.name}</span>
    )}
    {rentalCarsLeadOffer.rentalCarsShelfPrice && (
      <span className={`${rentalCarsLeadOffer.scoped ? styles.name : styles.price}`}>
        {localize('rental_car_rate_card_pricing', { currencyFare }) /* From {currencyFare}/day */}
      </span>
    )}
    {rentalCarsLeadOffer.scoped && (
      <span className={`${styles.note}`}>{rentalCarsLeadOffer.rentalCarType}</span>
    )}
  </React.Fragment>
);

const getOfferContainer = (
  url: ?string,
  currencyFare: string,
  rentalCarsLeadOffer: RentalCarsLeadOffer,
  logInteraction: LogInteraction,
) => {
  if (url) {
    return (
      <Link
        href={url}
        className="item poi_name ui_link"
        onClick={e => logInteraction(e, 'feedClick')}
      >
        {getOffer(currencyFare, rentalCarsLeadOffer)}
      </Link>
    );
  }

  return <div className="item poi_name ui_link">{getOffer(currencyFare, rentalCarsLeadOffer)}</div>;
};

type Props = {|
  /* Rental cars shelf info object */
  rentalCarsLeadOffer: RentalCarsLeadOffer,
|};

class ShelfRentalCarsSection extends React.PureComponent<Props> {
  render() {
    const { rentalCarsLeadOffer } = this.props;
    const url = rentalCarsLeadOffer?.route?.url;
    const currencyFare = globalize.formatCurrencyInteger(rentalCarsLeadOffer.rentalCarsShelfPrice);
    const sources = [
      {
        url: rentalCarsLeadOffer.carImage,
        height: 150,
        width: 225,
      },
    ];

    return (
      <InteractionLogger>
        {logInteraction => (
          <div className={styles.section}>
            <React.Fragment>
              {getPhotoContainer(url, sources, logInteraction)}
              {getOfferContainer(url, currencyFare, rentalCarsLeadOffer, logInteraction)}
              {url && <Link href={url} onClick={e => logInteraction(e, 'feedClick')} />}
            </React.Fragment>
          </div>
        )}
      </InteractionLogger>
    );
  }
}

export default ShelfRentalCarsSection;
